import { CardSelectComponentComponent } from './../../../../../../shared/components/card-select-component/card-select-component.component';
import { RefBusiness } from './../../../../../../models/refBusiness.model';
import { ContentActivityPrestations, ContentActivity, ContentExpression } from '../../../../../../models/contentActivityPrestations.model';
import { AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Block } from '../../../../../../models/block.model';
import { Component as ComponentModel } from '../../../../../../models/component.model';
import { CustomerPageData } from '../../../../../../models/customerPageData.model';
import { KeyValue } from '@angular/common';
import { ComponentType } from '../../../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../../../shared/enums/input-type/input-type.module';
import { SelectType } from '../../../../../../shared/enums/select-type/select-type.module';
import { FileStatus } from '../../../../../../shared/enums/file-status/file-status.module';
import { FileData } from '../../../../../../models/fileData.model';
import { FileCategory } from '../../../../../../models/fileCategory.model';
import { GeneralParameterService } from '../../../../../../services/generalparameter/generalparameter.service';
import { CustomerPageDataService } from '../../../../../../services/customerPageData/customerPageData.service';
import { SnackbarService } from '../../../../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { UtilsService } from '../../../../../../services/shared/utils/utils.service';
import { GeneralParameter } from '../../../../../../models/generalParameter.model';
import { DailySchedule, Period, Schedule } from '../../../../../../models/schedule.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Customer } from '../../../../../../models/customer.model';
import { Router } from '@angular/router';
import { RoleType } from '../../../../../../shared/enums/role-type/role-type.module';
import { CustomerPage } from '../../../../../../models/customerPage.model';
import { ColorPicker } from '../../../../../../models/colorPicker.model';
import { TooltipPosition } from '../../../../../../models/tooltipPosition.model';
import { DialogService } from '../../../../../../services/shared/dialog/dialog.service';
import { OfferStatus } from '../../../../../../shared/enums/offer-status/offer-status.module';
import { FileDataService } from '../../../../../../services/fileData/file-data.service';
import { BehaviorSubject, combineLatest, distinctUntilChanged, fromEvent, map, Observable, of, startWith, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';
import { CommonService } from '../../../../../../services/shared/common/common.service';
import { App } from '../../../../../../shared/enums/app/app.module';
import { RefBusinessLists } from '../../../../../../models/refBusinessLists.model';
import { OptionsType } from '../../../../../../shared/enums/options-type/options-type.module';
import { ContentAddress } from '../../../../../../models/contentAddress.model';
import { ContentIntitule } from '../../../../../../models/contentIntitule.model';
import { MatAutocomplete, MatAutocompleteActivatedEvent, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { SelectOption } from '../../../../../../models/selectOption.model';
import { ContentUrl } from '../../../../../../models/contentUrl.model';
import { ConnectionDefinition } from '../../../../../../models/connectionDefinition.model';
import { Direction } from '../../../../../../shared/enums/direction/direction.module';
import { EndpointType } from '../../../../../../shared/enums/endpoint-type/endpoint-type.module';
import { AutoCompleteTriggerService } from '../../../../../../services/shared/auto-complete-trigger/auto-complete-trigger.service';
import { OperatorType } from '../../../../../../shared/enums/operator-type/operator-type.module';
import { AppStateService } from '../../../../../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-component-form',
  templateUrl: './component-form.component.html',
  styleUrl: './component-form.component.css'
})
export class ComponentFormComponent implements OnInit, DoCheck, OnDestroy, AfterViewInit {
  private destroy$ = new Subject<void>();
  @Input() customerPage!: CustomerPage;
  @Input() block!: Block;
  @Input() component!: ComponentModel;
  @Input() customerId: string | undefined;
  @Input() customer!: Customer;
  @Input() isSummary!: boolean;
  @Input() userRole!: RoleType;
  @Input() dataIndex: number | undefined; //dataGroupCustomerPageData index
  @Input() index!: number; //customerPageData index

  @Input() customerPageData!: CustomerPageData; //current component data
  @Input() dataGroupCustomerPageData!: KeyValue<string, CustomerPageData[]>; //current dataGroup components data
  @Input() groupCustomerPageData!: CustomerPageData[]; //current group components data
  @Input() totalDataGroups!: number; //total dataGroups
  @Input() pageCustomerPageData!: CustomerPageData[]; //current page components data

  @Input() offerStatus!:OfferStatus;

  @Input() isConditionedClosed!: Boolean;

  @Input() refBusinessLists!: RefBusinessLists;
  @Input() fullConnectionsDefinitions!: ConnectionDefinition[];

  @Input() isCurrentBlock!: boolean;

  @Output() customersDataChange = new EventEmitter<boolean>();
  @Output() scrollToSchedule: EventEmitter<HTMLElement> = new EventEmitter();
  @Output() fieldContainerClick = new EventEmitter<HTMLElement>();
  @Output() recalculateTooltipsPosition = new EventEmitter;
  @Output() closeAllTooltipsExceptCurrent = new EventEmitter<string>();
  @Output() activityChanged = new EventEmitter;

  @ViewChildren('autoResizeTextarea') textareas!: QueryList<ElementRef>;
  @ViewChild('previewSchedule') previewSchedule!: ElementRef;
  @ViewChild('editSchedule') editSchedule!: ElementRef;
  @ViewChildren('fieldContainer') fieldContainers!: QueryList<ElementRef>;

  ComponentType = ComponentType;
  InputType = InputType;
  SelectType = SelectType;
  RoleType = RoleType;
  defaultColor: string = '#00000000';
  FileStatus = FileStatus;
  componentsConditioned: ComponentModel[] = [];
  filesData: FileData[] = [];
  allFileCategories: FileCategory[] = [];
  selectedDay: string = "Monday";
  editing = false;
  extensionsString: string = "";
  saveTimeout: any;

  isPreview = false;
  isEditable: boolean = false;
  isEditableWhenNotSummary: boolean = false;

  generatedIndex: string = "";

  shouldEvaluateField: boolean = false;

  isScheduleValid: boolean = true;
  isAddressValid: boolean = true;
  isUrlValid: boolean = true;

  itsConditioner: boolean = false;

  isCheckboxComponentChecked: boolean = false;

  currentDisplayedConditionedComponents: ComponentModel[] = [];
  public isFullDayChecked = this.isSelectedDayFullDay();

  availableHours: string[] = [];
  App = App;

  countries: RefBusiness[] = [];
  urlTypes: RefBusiness[] = [];

  componentConnectionsDefinitions: ConnectionDefinition[] = [];

  blurTimeout: any;
  pageSize = 20;
  currentPage = 1;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  @ViewChild('optionInput') optionInput: ElementRef<HTMLInputElement> | undefined = undefined;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  //single/multiple select
  optionCtrl = new FormControl({ value: '', disabled: !this.isEditable });
  searchCtrl = new FormControl('');
  private filteredStateSubject = new BehaviorSubject<{ isWaitingForInput: boolean, notFound: boolean, filteredOptions: SelectOption[] }>({
    isWaitingForInput: true,
    notFound: false,
    filteredOptions: []
  });
  filteredState: Observable<{ isWaitingForInput: boolean, notFound: boolean, filteredOptions: SelectOption[] }> = this.filteredStateSubject.asObservable();
  allOptions: SelectOption[] = [];
  filteredAllOptions: SelectOption[] = [];
  displayedOptions: SelectOption[] = [];

  //prestation activities
  @ViewChild('autoActivities') matAutocompleteActivities!: MatAutocomplete;
  @ViewChild('autoPrestations') matAutocompletePrestations!: MatAutocomplete;
  @ViewChild('prestationInput') prestationInput: ElementRef<HTMLInputElement> | undefined = undefined;
  selectedActivityCode = new BehaviorSubject<string | undefined>(undefined);
  activityCtrl = new FormControl();
  activitySearchCtrl = new FormControl();
  private filteredActivitiesStateSubject = new BehaviorSubject<{ isWaitingForInput: boolean, notFound: boolean, filteredActivities: ContentActivity[] }>({
    isWaitingForInput: true,
    notFound: false,
    filteredActivities: []
  });
  filteredActivitiesState: Observable<{ isWaitingForInput: boolean, notFound: boolean, filteredActivities: ContentActivity[] }> = this.filteredActivitiesStateSubject.asObservable();
  allActivities$ = new BehaviorSubject<ContentActivity[]>([]);
  @Input() activitiesAlreadySelected!: string[];
  filteredAllActivities: ContentActivity[] = [];
  displayedActivities: ContentActivity[] = [];

  private page$ = new BehaviorSubject<number>(1);
  availableActivityPrestations: RefBusiness[] = [];
  hasAvailablePrestations = false;
  prestationCtrl = new FormControl({ value: '', disabled: !this.isEditable });
  filteredPrestationsState: Observable<{ isWaitingForInput: boolean, notFound: boolean, filteredPrestations: ContentExpression[] }> = of({
    isWaitingForInput: true,
    notFound: false,
    filteredPrestations: []
  });
  filteredAllPrestations: ContentExpression[] = [];
  displayedPrestations: ContentExpression[] = [];
  private sub!: Subscription;

  OptionsType = OptionsType;

  oldValues: (string | Schedule | ColorPicker | FileData | ContentAddress | ContentIntitule | ContentUrl | ContentActivityPrestations)[] = [];

  hasConnectionsOut: boolean = false;

  componentFullType: string = "";
  @ViewChild('htmlWrapper')
  set htmlWrapper(ref: ElementRef<HTMLElement>) {
    if (!ref) return;
    if (!this.isAndroidOrWindows()) {
      ref.nativeElement.addEventListener(
        'click',
        this.onHtmlClick,
        true
      );
    }
  }

  constructor(private router: Router,
    private generalParameterService: GeneralParameterService,
    private customerPageDataService: CustomerPageDataService,
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    private utils: UtilsService,
    private dialogService: DialogService,
    private fileData: FileDataService,
    private commonService: CommonService,
    private autoCompleteTriggerService: AutoCompleteTriggerService,
    private appState: AppStateService) { }

  ngDoCheck() {
    if ((this.component.type === ComponentType.INPUT && this.component.config?.inputType == InputType.FILE) || this.component.type === ComponentType.VISUAL_PUBLICATION)
    {
      this.filesData = this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key);
    }
  }
  ngOnDestroy(): void {
    if(this.component.conditions && this.component.conditions.some(x => x.rules))
    {
      this.recalculateTooltipsPosition.emit();
    }
    this.destroy$.next();
    this.destroy$.complete();

    this.sub.unsubscribe();

    this.showMaskTypedList = {};
  }

  ngOnInit() {
    if(this.component.conditions && this.component.conditions.some(x => x.rules))
    {
      this.recalculateTooltipsPosition.emit();
    }

    this.isPreview = this.appState.getIsPreview();
    this.isEditableWhenNotSummary = this.commonService.isComponentEditable(this.component, this.offerStatus, this.fullConnectionsDefinitions, this.userRole, this.isPreview);
    this.isEditable = this.isEditableWhenNotSummary && !this.isSummary

    this.coverMissingInputs();
    if ((this.component.type === ComponentType.INPUT && this.component.config?.inputType == InputType.FILE)
      || this.component.type == ComponentType.VISUAL_PUBLICATION) {
      this.filesData = this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key);
      this.generalParameterService.getGeneralParameters('FileTypes')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (param: GeneralParameter[] | GeneralParameter) => {
          if (param != null && param.values.length > 0) {
            let fileCategories = (param.values) as FileCategory[];
            this.allFileCategories = (param.values) as FileCategory[];
            let extensions: string[] = [];

            if (this.component && this.component.config!.fileType && this.component.config!.fileType.length > 0) {
              fileCategories = fileCategories.filter(x => this.component.config!.fileType!.includes(x.type));
            }

            fileCategories.forEach(fileCategory => {
              fileCategory.valuesText = fileCategory.values.join(', ');
              extensions.push(...fileCategory.values);
            });

            this.extensionsString = extensions.join(', ');

            //build thumbnail
            this.customerPageData.values = this.customerPageData.values.map(item => {
              const fileData = item as FileData;
              const url = fileData.url;
              const lastSlashIndex = url?.lastIndexOf('/');
              var isNewDam = fileData.identifier && fileData.identifier.length > 0 && url?.includes("newdam");

              if (isNewDam && lastSlashIndex !== -1) {
                const basePath = url!.substring(0, lastSlashIndex! + 1);
                const fileName = url!.substring(lastSlashIndex! + 1);
                const newUrl = `${basePath}thumbnail/thumbnail_${fileName}`;

                return{
                  ...fileData,
                  urlThumbnail: newUrl
                }
              }

              return item;
            });

            const values = this.customerPageData.values;
            if (Array.isArray(values) && values.length > 0) {

              const firstValue = values[0];
              if (typeof firstValue === 'object') {
                this.fileData.fileDataMap.set(this.dataGroupCustomerPageData.key + '_' + this.component.id, values as FileData[]);
                this.fileData.notifyChanges();
                this.getFiles();
              }
            }
            else {
              this.fileData.fileDataMap.set(this.dataGroupCustomerPageData.key + '_' + this.component.id, []);
              this.fileData.notifyChanges();
            }
          }
        },
        error: (error) => { }
      });
    }
    else if (this.component.type == ComponentType.SCHEDULE) {
      if(this.refBusinessLists.hours && this.refBusinessLists.hours.length > 0)
      {
        this.availableHours = this.refBusinessLists.hours ? this.refBusinessLists.hours.map(hour => hour.labelBusiness) : [""];
      }
      else{
        this.customerPageDataService.getRefBusinessLists()
        .subscribe({
          next: (lists: RefBusinessLists) => {
            this.availableHours = lists.hours ? lists.hours?.map(hour => hour.labelBusiness) : [""];
          },
          error: (error) => {
            this.snackBar.showError(this.translationService.translate('Error fetching hours'));
          }
        });
      }

      this.evaluateSchedule();
    }
    else if(this.component.type == ComponentType.CHECKBOX)
    {
      this.isCheckboxComponentChecked = this.customerPageData.values[0] == "1";
    }
    else if(this.component.type == ComponentType.SELECT)
    {
      if(this.component.config?.optionsType == OptionsType.ACTIVITIES)
      {
        if(this.refBusinessLists.activities && this.refBusinessLists.activities.length > 0)
        {
          this.component.config!.options = this.refBusinessLists.activities?.map(activity => ({
            value: activity.code,
            display: activity.labelBusiness
          }));
        }
      }
      else if(this.component.config?.optionsType == OptionsType.CERTIFICATIONS
        || this.component.connections?.some(x => x.connectionDefinition?.app == App.CONTENT && x.connectionDefinition.values?.[0].name == 'certification'))
      {
        if(this.refBusinessLists.certifications && this.refBusinessLists.certifications.length > 0)
        {
          this.component.config!.options = this.refBusinessLists.certifications?.map(certification => ({
            value: certification.code,
            display: certification.labelBusiness,
            logoPath: certification.logoPath
          }));
        }
      }

      if(this.component.config?.selectType == SelectType.LIST_DROP)
      {
        if (!this.isEditable) {
          this.optionCtrl.disable();
        }
        else{
          this.optionCtrl.enable();
        }

        const optionValue = this.customerPageData.values[0] as string;
        if(optionValue)
        {
          this.optionCtrl.setValue(optionValue);
        }

        const sourceCtrl = this.component.config?.multipleAnswers
          ? this.optionCtrl.valueChanges
          : this.searchCtrl.valueChanges;

        const availableOptions = this.component.config?.options ?? [];
        this.allOptions = availableOptions;
        this.autocompletedOpenedType = "select";
        this.resetSelect();
        this.autocompletedOpenedType = "";

        sourceCtrl.pipe(
          startWith(''),
          takeUntil(this.destroy$),
          map((searchedOption: string | null) => {
            const value = searchedOption?.toLowerCase() ?? '';
            this.filteredAllOptions = this.allOptions.filter(opt =>
              !value || opt.display.toLowerCase().includes(value)
            );

            this.currentPage = 1;
            this.displayedOptions = this.filteredAllOptions.slice(0, this.pageSize);

            return {
              isWaitingForInput: false,
              notFound: this.filteredAllOptions.length === 0,
              filteredOptions: this.displayedOptions,
            };
          })
        ).subscribe(newState => {
          this.filteredStateSubject.next(newState);
        });
      }
    }
    else if(this.component.type == ComponentType.ADDRESS)
    {
      if(this.refBusinessLists.countries)
      {
        this.countries = this.refBusinessLists.countries;
      }
    }
    else if(this.component.type == ComponentType.INTITULE)
    {
      //
    }
    else if(this.component.type == ComponentType.URL)
    {
      if(this.refBusinessLists.urlTypes)
      {
        this.urlTypes = this.refBusinessLists.urlTypes;
      }
    }
    else if(this.component.type == ComponentType.ACTIVITY_PRESTATIONS)
    {
      if (!this.isEditable) {
        this.prestationCtrl.disable();
        this.activityCtrl.disable();
      }
      else{
        this.prestationCtrl.enable();
        this.activityCtrl.enable();
      }

      //prepared just for only one activity
      const activityPrestation = this.customerPageData.values[0] as ContentActivityPrestations;
      const activityCode = activityPrestation && activityPrestation.activity
        ? activityPrestation.activity.code
        : undefined;

      if(activityPrestation.prestations.length > 0)
      {
        this.activityCtrl.disable();
      }

      if (activityCode) {
        this.activityCtrl.setValue(activityPrestation.activity);
        this.updateAvailableActivityPrestations(activityCode);
      }

      this.updateAvailableActivities();
      this.autocompletedOpenedType = "activities";
      this.resetSelect();
      this.autocompletedOpenedType = "";

      combineLatest([
        this.activitySearchCtrl.valueChanges.pipe(startWith('')),
        this.allActivities$
      ])
      .pipe(
        map(([searchedActivity, allActivities]) => {
          const value = searchedActivity?.toLowerCase() ?? '';

          this.filteredAllActivities = allActivities.filter(opt =>
            !value || opt.label.toLowerCase().includes(value)
          );

          this.currentPage = 1;
          this.displayedActivities = this.filteredAllActivities.slice(0, this.pageSize);

          return {
            isWaitingForInput: false,
            notFound: this.filteredAllActivities.length === 0,
            filteredActivities: this.displayedActivities,
          };
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(state => this.filteredActivitiesStateSubject.next(state));


      this.selectedActivityCode.next(activityCode);

      //prestations
      const search$ = this.prestationCtrl.valueChanges.pipe(
        startWith(''),
        distinctUntilChanged(),
        map(value => typeof value === 'string' ? value : ''),
        tap(() => this.page$.next(1))
      );

      this.filteredPrestationsState = combineLatest([
        this.selectedActivityCode,
        search$,
        this.page$
      ]).pipe(
        map(([activityCode, searchedPrestation, page]: [string | undefined, string, number]) => {
          if (!activityCode) {
            return { isWaitingForInput: true, notFound: false, filteredPrestations: [] };
          }

          if (page === 1) {
              this.updateAvailableActivityPrestations(activityCode);
              this.filteredAllPrestations = this.filterPrestations(activityCode, searchedPrestation);
          }

          const displayedPrestations = this.filteredAllPrestations.slice(0, this.pageSize * page);

          return {
            isWaitingForInput: false,
            notFound: this.filteredAllPrestations.length === 0 && !!searchedPrestation,
            filteredPrestations: displayedPrestations
          };
        })
      );
    }

    if (this.component.type != ComponentType.SCHEDULE && !this.component.config?.multipleAnswers && this.customerPageData.values.length > 1) {
      this.customerPageData.values = [this.customerPageData.values[0]]
    }

    //mask read regex+format
    this.formatOnRead();

    this.generatedIndex = this.utils.generateGUID();

    this.itsConditioner = this.hasComponentsConditionedBy();
    setTimeout(() => {
      this.adjustAllTextareasHeight();
      this.oldValues = structuredClone(this.customerPageData.values);
    }, 1);

    this.isFullDayChecked = this.isSelectedDayFullDay();
    this.currentDisplayedConditionedComponents = this.getConditionedComponents("display", false);

    this.componentFullType =
      ComponentType[this.component.type!]
      + (this.component.config?.inputType != undefined ? '_' + InputType[this.component.config.inputType] : '')
      + (this.component.config?.selectType != undefined ? '_' + SelectType[this.component.config.selectType] : '');

    this.hasConnectionsOut = this.component.connections != undefined && this.component.connections.some(x => x.direction == Direction.IN_OUT || x.direction == Direction.OUT);
    this.editing = this.component.type == ComponentType.ADDRESS ? !this.hasConnectionsOut : false;
  }

  ngAfterViewInit() {
    //could be component multiple
    this.fieldContainers.forEach((field: ElementRef) => {
      if (field.nativeElement.closest('.summary-modal')) {
        field.nativeElement.addEventListener('click', this.handleFieldContainerClick.bind(this));
      }
    });

    this.sub = this.autoCompleteTriggerService.closeAll$.subscribe(() => {
      if (this.autocompleteTrigger) {
        this.autocompleteTrigger.closePanel();
      }
    });

    if (this.searchInput) {
      fromEvent<KeyboardEvent>(this.searchInput.nativeElement, 'keydown')
        .pipe(takeUntil(this.destroy$))
        .subscribe(event => this.handleKeydown(event));
    }
  }

  handleKeydown(event: KeyboardEvent) {
    if (this.autocompleteTrigger?.panelOpen && this.searchInput &&
        (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      this.autocompleteTrigger._handleKeydown(event);
    }
  }
  handleFieldContainerClick(event: Event) {
    const target = event.target as HTMLElement;
    this.fieldContainerClick.emit(target);
  }
  onFieldContainerClick(element: HTMLElement) {
    this.fieldContainerClick.emit(element);
  }
  handleCustomerPageDatasChange(event: boolean){
    this.customersDataChange.emit(event);
  }
  scrollToScheduleEvent(scheduleElement: HTMLElement){
    this.scrollToSchedule.emit(scheduleElement!);
  }
  onTooltipPositionChanged(positionData: TooltipPosition){
    this.tooltipPosition.emit(positionData);
  }


  //text, number, date, text area, color picker
  onInputSave(value: any, index: number) {
    const isNumberType = this.component.config?.inputType === InputType.NUMBER;
    const currentValue = isNumberType
      ? this.customerPageData.values[index] != null
        ? String(this.customerPageData.values[index])
        : ""
      : value;

    const hasError = this.evaluateField(currentValue, index.toString());

    if (isNumberType) {
      if (this.saveTimeout) clearTimeout(this.saveTimeout);

      this.saveTimeout = setTimeout(() => {
        if (!hasError) this.onSave();
      }, 3000);
    } else {
      if (!hasError) this.onSave();
    }

    this.toggleMask(index, false);
  }

  onInputTextInsert(value: any, index: number){
    const stringValue = (value !== null && value !== undefined) ? String(value) : "";
    this.customerPageData.values[index] = stringValue;
    this.customersDataChange.emit(true);
  }

  onSave(i?: number) {
    if (this.isEditable) {
      if (this.component.config?.multipleAnswers === true) {
        setTimeout(() => {
          this.evaluateAllComponentFields(true, true);
        }, 0);
      }

      this.executeSave();
    }
  }

  executeSave() {

    if (this.component.type === ComponentType.SCHEDULE) {
      this.customerPageData.values.forEach(value => {
        var schedule = value as Schedule;
        const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

        daysOfWeek.forEach(day => {
          const daySchedule = schedule[day];

          if (daySchedule && Array.isArray(daySchedule.periods)) {
            daySchedule.periods = daySchedule.periods.filter(period =>
              this.getPeriodValidationError(period, daySchedule.periods) === ""
            );

            daySchedule.periods.forEach(period => {
              period.openingTime = this.ensureSeconds(period.openingTime);
              period.closingTime = this.ensureSeconds(period.closingTime);
            });

            daySchedule.periods.sort((a, b) => {
              const openingA = this.convertToMinutes(a.openingTime);
              const openingB = this.convertToMinutes(b.openingTime);
              return openingA - openingB;
            });
          }
        });
      });
      this.editing = false;
      this.isScheduleValid = true;
      this.emitScrollToSchedule('preview');
    }
    else if ((this.customerPageData.component.type === ComponentType.INPUT && this.component.config?.inputType == InputType.FILE)
    || this.customerPageData.component.type === ComponentType.VISUAL_PUBLICATION) {
      this.customerPageData.values = this.fileData
        .getFiles(this.component.id, this.dataGroupCustomerPageData.key)
        .filter(x => x.fileStatus == FileStatus.UPLOADING || x.fileStatus == FileStatus.SUCCESS) as FileData[];
    }
    else if (this.component.type === ComponentType.INPUT && this.component.config?.inputType === InputType.COLOR_PICKER) {
      this.customerPageData.values = this.customerPageData.values.map(value => {
        var colorPicker = value as ColorPicker;
        this.hasAlphaZero(colorPicker.color);
        if (colorPicker.color.startsWith('#')) {
          return colorPicker;
        } else {
          return {
            ...colorPicker,
            color: this.utils.rgbaToHex(colorPicker.color)
          };
        }
      });
    }
    else if(this.component.type === ComponentType.CHECKBOX)
    {
      this.customerPageData.values = [this.customerPageData.values[0]];
    }
    else if(this.customerPageData.component.type === ComponentType.INPUT || this.customerPageData.component.type === ComponentType.SELECT) {
      this.customerPageData.values = this.customerPageData.values.map(value => value === null ? '' : String(value));
    }

    this.customersDataChange.emit(true);

    setTimeout(() => {
      if (this.isEditable && !this.isPreview) {
        const mask = this.component.config?.mask;
        var valuesToSave = this.customerPageData.values
          .map(val => {
            if (val && mask?.writeRegex && mask?.writeFormat) {
              const regex = new RegExp(mask.writeRegex);
              if (regex.test(String(val))) {
                return String(val).replace(regex, mask.writeFormat);
              }
            }
            return val;
          })
          .filter(value =>!(this.component.type == ComponentType.INPUT && this.component.config?.multipleAnswers) || value !== ''); //save on bd without empty string on input multiple

        const completionPercent = this.customerPage.completionPercent ?? 0;
        this.customerPageDataService.save(this.customerPageData, valuesToSave, completionPercent)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (id) => { /* ID already updated in service via reference */ },
          error: () => this.snackBar.showError(this.translationService.translate('Error saving data'))
          });

        var conditionedComponents = this.getConditionedComponents("display", false);
        this.handleConditionedComponents(conditionedComponents);
        this.currentDisplayedConditionedComponents = conditionedComponents;
      }
    }, 0);
  }

  executeSaveProcess(component: ComponentModel, customerPageData: CustomerPageData)
  {
    if (this.commonService.isComponentEditable(component, this.offerStatus, this.fullConnectionsDefinitions, this.userRole, this.isPreview) && !this.isPreview) {
      const mask = component.config?.mask;
      var valuesToSave = customerPageData.values
      .map(val => {
        if (val && mask?.writeRegex && mask?.writeFormat) {
          const regex = new RegExp(mask.writeRegex);
          if (regex.test(String(val))) {
            return String(val).replace(regex, mask.writeFormat);
          }
        }
        return val;
      })
      .filter(value =>!(component.type == ComponentType.INPUT && component.config?.multipleAnswers) || value !== ''); //save on bd without empty string on input multiple

      var completionPercent = this.customerPage.completionPercent ?? 0;
      this.customerPageDataService.save(customerPageData, valuesToSave, completionPercent)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (id) => { /* ID already updated in service via reference */ },
        error: () => this.snackBar.showError(this.translationService.translate('Error saving data'))
      });
    }
  }

  onEditSchedule(tooltipIndex: string) {
    if(this.isEditable)
    {
      this.currentSelectedDayPeriods = this.getSelectedDayPeriods();
      this.editing = true;
      this.emitScrollToSchedule('edit');
      this.displayCurrentErrorTooltip(tooltipIndex);
    }
  }

  emitScrollToSchedule(type: string) {
    setTimeout(() => {
      var element: HTMLElement;
      if (type === 'preview') {
        element = this.previewSchedule.nativeElement;
      } else if (type === 'edit') {
        element = this.editSchedule.nativeElement;
      }
      this.scrollToSchedule.emit(element!);
    });
  }

  coverMissingInputs() {
    if (this.component.config?.multipleAnswers && this.customerPageData.values.length < this.component.multipleConfig!.initQuantity) {
      var missingValuesToInit = this.component.multipleConfig!.initQuantity - this.customerPageData.values.length;
      for (let index = 0; index < missingValuesToInit; index++) {
        this.addAnswer();
      }
    }
  }

  isAllValuesComponentEmpty(): boolean {
    return this.customerPageData.values.length === 0 || this.customerPageData.values.every(value =>
      value == null ||
      value === ''
    );
  }

  isAllValuesDataGroupEmpty(): boolean {
    return this.dataGroupCustomerPageData.value.every(customerPageData =>
      customerPageData.values == null ||
      customerPageData.values.length === 0 ||
      customerPageData.values.every(value => value === '' || value === null)
    );
  }


  onCheckboxChange(key: string, event: MatCheckboxChange): void {
    let values = this.customerPageData.values as string[];
    if (event.checked) {
      if (!values.includes(key)) {
        values.push(key);
      }
    } else {
      const index = values.indexOf(key);
      if (index > -1) {
        values.splice(index, 1);
      }
    }
    this.evaluateField();
    this.onSave();
  }

  onRadioSelect(value: string) {
    this.displayCurrentErrorTooltip(this.generatedIndex);
    this.evaluateField();
  }


  onSelectSingleChange(value: string): void {
    this.optionCtrl.setValue(value);
    this.customerPageData.values = [value];

    this.searchCtrl.setValue('');

    this.evaluateField();
    this.onSave();
  }

  onSelectSingleFocusOut()
  {
    this.searchCtrl.setValue('');
    setTimeout(() => {
      this.resetSelect();
    }, 150);
  }

  openPanelManually(tooltipIndex: string) {
    //prevent change activity when has prestations
    if(this.component.type == ComponentType.ACTIVITY_PRESTATIONS && this.customerPageDataValuesInActivityPrestations[0].prestations.length > 0)
      return;

    this.autocompleteTrigger.openPanel();
    this.displayCurrentErrorTooltip(tooltipIndex);
  }

  onClickInputPrestation(tooltipIndex: string)
  {
    setTimeout(() => {
      if (this.prestationInput) {
        this.prestationInput.nativeElement.focus();
      }
    }, 0);
    this.displayCurrentErrorTooltip(tooltipIndex);
  }

  autocompletedOpenedType = "";
  onPanelOpen(type: string) {
    this.autocompletedOpenedType = type;
    setTimeout(() => {
      const autoComplete = type == 'select' ?
                            this.matAutocomplete
                            : type == 'activities' ?
                              this.matAutocompleteActivities
                              : type == 'prestations' ?
                                this.matAutocompletePrestations
                                : undefined;
      const panel = autoComplete?.panel?.nativeElement as HTMLElement | undefined;
      if (panel) {
        panel.addEventListener('scroll', this.onPanelScroll.bind(this));
      }
    }, 0);

    setTimeout(() => {
      if(this.searchInput)
      {
        this.searchInput.nativeElement.focus();
      }
    }, 1);
  }

  resetSelect()
  {
    const autoComplete = this.autocompletedOpenedType == 'select' ?
                      this.matAutocomplete
                      : this.autocompletedOpenedType == 'activities' ?
                        this.matAutocompleteActivities
                        : this.autocompletedOpenedType == 'prestations' ?
                          this.matAutocompletePrestations
                          : undefined;
    const panel = autoComplete?.panel?.nativeElement as HTMLElement | undefined;
    if (panel) {
      panel.removeEventListener('scroll', this.onPanelScroll.bind(this));
    }

    this.currentPage = 1;

    if(this.autocompletedOpenedType =="select"){
      this.filteredAllOptions = this.allOptions;
      this.displayedOptions = this.filteredAllOptions.slice(0, this.pageSize);
      this.filteredStateSubject.next({
        isWaitingForInput: false,
        notFound: false,
        filteredOptions: this.displayedOptions
      });
    }
    else if(this.autocompletedOpenedType =="activities"){
      this.filteredAllActivities = this.allActivities$.value;
      this.displayedActivities = this.filteredAllActivities.slice(0, this.pageSize);
      this.filteredActivitiesStateSubject.next({
        isWaitingForInput: false,
        notFound: false,
        filteredActivities: this.displayedActivities,
      });
    }
    else if(this.autocompletedOpenedType =="prestations"){
      this.page$.next(1);
    }
  }

  onPanelScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 10;

    if(this.autocompletedOpenedType =="select")
    {
      if (atBottom && this.displayedOptions.length < this.filteredAllOptions.length) {
        this.currentPage++;
        const nextItems = this.filteredAllOptions.slice(0, this.pageSize * this.currentPage);
        this.displayedOptions = nextItems;

        const currentState = this.filteredStateSubject.getValue();

        this.filteredStateSubject.next({
          ...currentState,
          filteredOptions: this.displayedOptions
        });
      }
    }
    else if(this.autocompletedOpenedType =="activities")
    {
      if (atBottom && this.displayedActivities.length < this.filteredAllActivities.length) {
        this.currentPage++;
        const nextItems = this.filteredAllActivities.slice(0, this.pageSize * this.currentPage);
        this.displayedActivities = nextItems;

        const currentState = this.filteredStateSubject.getValue();

        this.filteredActivitiesStateSubject.next({
          ...currentState,
          filteredActivities: this.displayedActivities
        });
      }
    }
    else if(this.autocompletedOpenedType =="prestations")
    {
      if (atBottom && this.displayedPrestations.length < this.filteredAllPrestations.length) {
        const currentlyDisplayedCount = this.filteredAllPrestations.slice(0, this.pageSize * this.page$.value).length;
        if (atBottom && currentlyDisplayedCount < this.filteredAllPrestations.length) {
          this.page$.next(this.page$.value + 1);
        }
      }
    }
  }

  private activeOption: MatOption | null = null;
  onOptionActivated(event: MatAutocompleteActivatedEvent): void {
    if (event.option) {
      this.activeOption = event.option;
    }
  }
  onSelectSearchEnter(event: Event): void {
    event.preventDefault();
    if (this.activeOption && this.activeOption.value) {
      this.onSelectSingleChange(this.activeOption.value);
      this.autocompleteTrigger.closePanel();
    }
  }

  onSelectMultipleChange() {
    this.evaluateField();
    this.onSave();
  }

  onChipSelected(event: MatAutocompleteSelectedEvent): void {
    clearTimeout(this.blurTimeout);
    const selectedValue = event.option.value;
    if (selectedValue && !this.customerPageData.values.includes(selectedValue)) {
      this.customerPageData.values.push(selectedValue);
    }

    if(this.optionInput)
    {
      this.optionInput.nativeElement.value = '';
    }
    this.optionCtrl.setValue(null);
    this.onSelectMultipleChange();
  }

  // in test
  onClickInputSelectMultiple(tooltipIndex: string)
  {
    setTimeout(() => {
      if (this.optionInput) {
        this.optionInput.nativeElement.focus();
      }
    }, 0);
    this.displayCurrentErrorTooltip(tooltipIndex);
  }
  //

  onSelectMultipleFocusOut()
  {
    this.blurTimeout = setTimeout(() => {
      if (this.optionInput) {
        this.optionInput.nativeElement.value = '';
      }
      this.optionCtrl.setValue(null);

      this.resetSelect();
    }, 150);
  }

  removeChip(value: string): void {
    const index = this.customerPageData.values.indexOf(value);

    if (index >= 0) {
      this.customerPageData.values.splice(index, 1);
      this.onSelectMultipleChange();
      this.optionCtrl.updateValueAndValidity();
    }

    if (this.autocompleteTrigger) {
      this.autocompleteTrigger.closePanel();
    }
  }

  getOptionDisplay(value: string): string {
    return this.component.config?.options?.find(opt => opt.value === value)?.display || String(value);
  }

  getOptionLogo(value: string): string {
    var logoPath = this.component.config?.options?.find(opt => opt.value === value)?.logoPath;
    return logoPath ?? "";
  }

  filterOptions(searchedOption?: string|null): SelectOption[] {
    const availableOptions = this.component.config?.options ?? [];

    return availableOptions.filter(option =>
      !searchedOption || option.display.toLowerCase().includes(searchedOption.toLowerCase())
    );
  }

  displayOption = (option: string): string => {
    var optionOnList = this.component.config?.options?.find(x => x.value == option);
    return option && optionOnList ? this.stripHtml(optionOnList.display) : '';
  };

  displayOptionRaw = (option: string): string => {
    var optionOnList = this.component.config?.options?.find(x => x.value == option);
    return option && optionOnList ? optionOnList.display : '';
  };

  get tooltipContent(): string {
    const value = this.optionCtrl.value || '';
    const rawValue = this.displayOptionRaw(value);

    return this.isHtml(rawValue) ? rawValue : '';
  }

  trackByFn(index: number, item: any) {
    return index;
  }

  getConditionedComponents(ruleAction: string = "", onlyClosed: boolean = false, targetValue: string = ""): ComponentModel[]{
    const blockComponents = this.block.componentGroups.flatMap(x => x.components);
    const conditionedComponents = blockComponents.filter(c => c.conditions?.some(cond => cond.componentId == this.component.id)); //TODO: buscar so condicionados em relação ao component atual?
    var allValues = this.customerPageData.values;

    if(this.component.type == ComponentType.CHECKBOX && allValues.every(x => x.toString().trim() == ""))
    {
      allValues = ["0"];
    }

    return conditionedComponents.filter(component => {
      var conditions = component.conditions;
      if (!conditions || conditions.length === 0) return true;

      if(component.config?.conditionPosition != 'closed' && onlyClosed) return false;

      var isConditionsSatisfied = conditions.every(condition => {
        var sourceComponent = blockComponents.find(c => c.id == condition.componentId);
        if (!sourceComponent){
          //when source is hidden by role
          return this.customerPageData.shouldDisplay == true;
        }

        //source of current conditioner
        const sourceComponentGroup = this.block.componentGroups.find(x => x.components.find(y => y.id === sourceComponent?.id));
        //conditioned
        const targetComponentGroup = this.block.componentGroups.find(x => x.components.find(y => y.id === component.id));
        if (!sourceComponentGroup || !targetComponentGroup) return false;

        //fetch conditioner values
        const values = this.commonService.getConditionerValues(this.pageCustomerPageData, sourceComponent, sourceComponentGroup, condition, targetComponentGroup!, this.dataGroupCustomerPageData, this.block.iteration);
        //fetch current component rules
        const rules = condition.rules.filter(rule => rule.action == ruleAction && rule.value !== null && rule.value !== undefined);

        var isConditionSatisfied = this.commonService.isConditionSatisfied(rules, sourceComponent, values);
        if(isConditionSatisfied && targetValue && onlyClosed && component.config?.conditionComponentTarget == this.component.id && component.config?.conditionPosition === 'closed'){
          // Used by the conditioner to decide where to display the closed condition
          // typically for select inputs, based on the current evaluated target.
          var equalSastified = rules.filter(r => (r.operatorType == undefined || r.operatorType == OperatorType.EQUAL) && this.commonService.isRuleSatisfied(r.value, values as string[]));
          var sourceValuesThatConditions = equalSastified.flatMap(r => r.value);
          // Uses the first satisfied EQUAL rule value,
          // otherwise falls back to the last assumed or available option value.
          var sourceValue = sourceValuesThatConditions.length > 0 ? sourceValuesThatConditions[0] : allValues.length > 0 ? allValues[allValues.length-1] : component.config!.options![0];
          return sourceValue == targetValue;
        }
        return isConditionSatisfied;
      });

      return isConditionsSatisfied;
    });
  }


  hasComponentsConditionedClosedDisplayed(targetValue: string = ""): boolean
  {
    return this.getConditionedComponents("display", true, targetValue).length > 0;
  }

  handleConditionedComponents(displayedConditionedComponents: ComponentModel[]){
    const currentIds = new Set(this.currentDisplayedConditionedComponents.map(c => c.id));
    const addedIds = new Set(displayedConditionedComponents.map(c => c.id));

    const removedComponents = this.currentDisplayedConditionedComponents.filter(c => !addedIds.has(c.id));
    const addedComponents = displayedConditionedComponents.filter(c => !currentIds.has(c.id));

    removedComponents.forEach(component => this.processComponent(component, true));
    addedComponents.forEach(component => this.processComponent(component, false));
  }

  processComponent(component: ComponentModel, isRemoving: boolean) {
    const componentGroup = this.block.componentGroups.find(group => group.components.some(c => c.id === component.id));
    const conditionPosition = component.config?.conditionPosition?.toLowerCase();
    const isSameGroup = componentGroup?.id === this.customerPageData.groupId || conditionPosition === 'closed';

    const componentPageDatas = isSameGroup
        ? [this.getCustomerPageDataByComponentId(component.id, this.customerPageData.dataGroupId)]
        : this.pageCustomerPageData.filter(customerPageData => customerPageData.component.id === component.id && customerPageData.blockIteration === this.block.iteration);

    componentPageDatas.forEach(customerPageData => {
        if (isRemoving) {
          const currentValues = customerPageData.values;
          customerPageData.values = component.type == ComponentType.URL ? [] : this.commonService.buildComponentDefaultValues(component.type!, component.config?.inputType, component.config?.multipleAnswers);

          if(component.type != ComponentType.URL){
          this.executeSaveProcess(component, customerPageData);
          }

          if(component.type != ComponentType.VISUAL_PUBLICATION && !(component.type == ComponentType.INPUT && component.config?.inputType == InputType.FILE)){
            customerPageData.values = currentValues;
          }
        } else {
          if(component.type != ComponentType.URL){
          this.executeSaveProcess(component, customerPageData);
        }
        }
    });
  }

  hasComponentsConditionedBy(): boolean
  {
    var components = this.block.componentGroups.flatMap(x => x.components);

    return components.some(component => component.conditions?.some(condition => condition.componentId == this.component.id && condition.rules.length > 0)
                                && component.config?.conditionPosition === 'closed');
  }


  getCustomerPageDataByComponentId(componentId: string, dataGroupId?: string) {
    const customersData = this.pageCustomerPageData.filter(customerPageData => customerPageData.component.id === componentId && customerPageData.blockIteration == this.block.iteration);

    if (customersData.length === 0) {
      throw new Error(`Component with id ${componentId} not found in customerPageDataGroup.`);
    }

    if (dataGroupId) {
      const customerPageData = customersData.find(customerPageData => customerPageData.dataGroupId === dataGroupId);
      if (customerPageData) {
        return customerPageData;
      }
      throw new Error(`Component with id ${componentId} not found in dataGroupId ${dataGroupId}.`);
    }

    return customersData[0];
  }


  addAnswer() {
    this.editing = true;
    if (this.component.type === ComponentType.INPUT) {
      if (this.component.config?.inputType === InputType.COLOR_PICKER) {
        let values = this.customerPageData.values as ColorPicker[];
        values.push({
          color: this.defaultColor,
          text: this.component.config.hasColorText === true ? "" : undefined
        });
        // this.onSave();
      }
      else if(this.component.config?.inputType != InputType.FILE) {
        let values = this.customerPageData.values as string[];
        values.push("");
      }
    }
    else if(this.component.type === ComponentType.URL){
      let values = this.customerPageData.values as ContentUrl[];
      var defaultType = this.component.config?.contentAPISubType;

      values.push({
        identifier: this.utils.generateGUID(),
        label: "",
        type: defaultType === "CUSTOM" ? "" : (defaultType ?? "")
      });
    }

    //mask read regex+format
    this.formatOnRead();

    this.customersDataChange.emit(true);
    this.recalculateTooltipsPosition.emit();
  }

  removeAnswer(index: number) {
    this.customerPageData.values.splice(index, 1);
    if(this.component.type == ComponentType.URL)
    {
      this.onUrlSave();
    }
    else{
      this.customersDataChange.emit(true);
      this.onSave();
    }

    delete this.errorMessages[this.generatedIndex+'-'+index];
    this.recalculateTooltipsPosition.emit();
  }

  canAddAnswers(insideUrl: boolean = false): boolean {
    return (this.component.config!.multipleAnswers === true
      && (!this.component.connections?.find(x => x.connectionDefinition?.values?.some(y => y.handle == "SINGLE")))
      &&(this.component.multipleConfig!.maxQuantity === undefined || this.component.multipleConfig!.maxQuantity === null || this.customerPageData.values.length < this.component.multipleConfig!.maxQuantity))
      && this.isEditable
      && this.component.type != ComponentType.SELECT
      && (insideUrl || this.component.type != ComponentType.URL)
      && this.component.type != ComponentType.VISUAL_PUBLICATION
      && !(this.component.type == ComponentType.INPUT && this.component.config?.inputType == InputType.FILE);
  }

  canRemoveAnswers(): boolean {
    return this.customerPageData.values.length > this.component.multipleConfig!.minQuantity && this.isEditable;

    // var isAllEmpty = this.isAllValuesComponentEmpty();

    // return ((!isAllEmpty && this.customerPageData.values.length > this.component.multipleConfig!.minQuantity)
    //   || (isAllEmpty && this.customerPageData.values.length > this.component.multipleConfig!.initQuantity)) && this.isEditable;
  }

  //#region SCHEDULE

  ensureSeconds(timeValue: string): string {
    if (timeValue && timeValue.length === 5) {
      return `${timeValue}:00`;
    }
    return timeValue || '';
  }

  //HH:mm
  formatTimeDisplay(time: string): string {
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      return time.slice(0, 5);
    }
    return time;
  }

  evaluatePeriodFields() {
    this.currentSelectedDayPeriods.forEach((period, index) => this.evaluateField(period, index.toString()));
  }

  onPeriodTimeChanged(period: Period) {
    this.fillMissingPeriodTime(period);
    this.isFullDayChecked = this.isSelectedDayFullDay();
    this.evaluateSchedule();
    this.evaluatePeriodFields();
  }

  fillMissingPeriodTime(period: Period)
  {
    const available = this.availableHours.map(h => `${h}:00`);
    const getNext = (time: string): string => {
      const idx = available.indexOf(time);
      if (idx === -1) return '';
      return available[(idx + 1) % available.length];
    };
    const getPrevious = (time: string): string => {
      const idx = available.indexOf(time);
      if (idx === -1) return '';
      return available[(idx - 1 + available.length) % available.length];
    };

    const opening = period.openingTime;
    const closing = period.closingTime;

    if (opening && !closing) {
      period.closingTime = getNext(opening);
    }
    if (closing && !opening) {
      period.openingTime = getPrevious(closing);
    }
  }

  addPeriod() {
    const schedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
    if (schedule) {
      var newPeriod: Period = { openingTime: '', closingTime: '' };
      schedule.periods.push(newPeriod);
      this.evaluateSchedule();

      var index = schedule.periods.length - 1;
      this.evaluateField(newPeriod, index.toString());
    }
  }

  removePeriod(periodIndex: number) {
    const schedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
    if (schedule) {
      schedule.periods.splice(periodIndex, 1);
      this.evaluateSchedule();

      setTimeout(() => {
        this.evaluatePeriodFields();
      }, 0);
    }
  }

  currentSelectedDayPeriods: Period[] = [];
  selectDay(day: string) {
    this.selectedDay = day;
    this.currentSelectedDayPeriods = this.getSelectedDayPeriods();
    this.evaluateSchedule();
    setTimeout(() => {
      this.evaluatePeriodFields();
      this.isFullDayChecked = this.isSelectedDayFullDay();
    }, 0);
  }

  getSelectedDayPeriods(): Period[] {
    const schedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
    return schedule ? schedule.periods : [];
  }

  get customerPageDataValuesInSchedule(): DailySchedule[] {
    const schedule = this.customerPageData?.values[0] as Schedule;
    if (schedule) {
      return Object.values(schedule).filter(
        (value): value is DailySchedule =>
          typeof value === 'object' &&
          value !== null &&
          'weekDay' in value
      );
    }
    else {
      return [];
    }
  }

  evaluateSchedule(): void {
    this.isScheduleValid = true;
    const selectedSchedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
    if (!selectedSchedule) {
      this.isScheduleValid = false;
    }

    const periods = selectedSchedule!.periods;

    if (periods && periods.length > 0) {
      for (const period of periods) {
        if (this.getPeriodValidationError(period, periods) !== "") {
          this.isScheduleValid = false;
          break;
        }
      }
    }
  }

  getPeriodValidationError(period: Period, periods: Period[]): string {

    if (this.isFullDay(periods)) {
      return "";
    }

    if (period.openingTime.trim() === "" || period.closingTime.trim() === "") {
      return this.translationService.translate("Incomplete schedule");
    }

    const openingTime = this.convertToMinutes(period.openingTime);
    const closingTime = this.convertToMinutes(period.closingTime);

    if (openingTime === closingTime) {
      return this.translationService.translate("Opening time equal to closing time");
    }

    if (openingTime > closingTime) {
      return this.translationService.translate("Opening time greater than closing time");
    }

    if (periods.length > 1) {
      for (const otherPeriod of periods) {
        if (otherPeriod === period) continue;
        const startOther = this.convertToMinutes(otherPeriod.openingTime);
        const endOther = this.convertToMinutes(otherPeriod.closingTime);
        if (openingTime < endOther && closingTime > startOther) {
          return this.translationService.translate("Period included within another period");
        }
      }
    }

    return "";
  }


  convertToMinutes(time: string): number {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  getTotalHoursFormatted(schedule: DailySchedule): string {
    const periods = schedule.periods;

    if (this.isFullDay(periods)) {
      return '24h';
    }

    let totalMinutes = 0;

    for (const period of periods) {
      if (!period.openingTime || !period.closingTime) continue;

      const [startHour, startMin] = period.openingTime.split(':').map(Number);
      const [endHour, endMin] = period.closingTime.split(':').map(Number);

      if (
        isNaN(startHour) || isNaN(startMin) ||
        isNaN(endHour) || isNaN(endMin)
      ) continue;

      const start = startHour * 60 + startMin;
      const end = endHour * 60 + endMin;

      if (end > start) {
        totalMinutes += end - start;
      }
    }

    if (isNaN(totalMinutes) || totalMinutes <= 0) {
      return this.translationService.translate('Closed');
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return minutes > 0
      ? `${hours}h${String(minutes).padStart(2, '0')}`
      : `${hours}h`;
  }

  isFullDay(periods: Period[]): boolean {
    return periods.length === 1 &&
      this.formatTimeDisplay(periods[0].openingTime) === '00:00' &&
      this.formatTimeDisplay(periods[0].closingTime) === '00:00';
  }

  isSelectedDayFullDay(): boolean {
    const schedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
    if (!schedule || !schedule.periods) return false;

    return schedule ? this.isFullDay(schedule.periods) : false;
  }

  onFullDayToggle(checked: boolean): void {
    this.dialogService.confirm(
      this.translationService.translate('Attention'),
      this.translationService.translate('This action will modify the form for the selected day. Do you want to continue?')
    ).then((confirmed) => {
      if (confirmed) {
        const schedule = this.customerPageDataValuesInSchedule.find(s => s.weekDay === this.selectedDay);
        if (schedule) {
          if (checked) {
            schedule.periods = [{ openingTime: '00:00:00', closingTime: '00:00:00' }];
          } else {
            schedule.periods = [];
          }
          this.currentSelectedDayPeriods = this.getSelectedDayPeriods();
          this.evaluateSchedule();
          setTimeout(() => {
            this.evaluatePeriodFields();
          }, 0);
        }
      } else {
        this.isFullDayChecked = this.isSelectedDayFullDay();
      }
    });
  }

  //#endregion

  get customerPageDataValuesInString(): string[] {
    return Array.isArray(this.customerPageData.values) && typeof this.customerPageData.values[0] === 'string'
      ? this.customerPageData.values as string[]
      : [];
  }

  //#region INPUT FILE + VISUAL PUBLICATION
  hasOnlyOneFileType(): boolean {
    return this.component.config!.fileType != null && this.component.config!.fileType!.length === 1;
  }

  getSingleFileType(): string | null {
    return this.hasOnlyOneFileType() ? this.component.config!.fileType![0] || null : null;
  }

  getFiles() {
    this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key).forEach(file => {

      file.fileStatus = FileStatus.UPLOADING;
      file.canDownload = true;
      if(file.fileName && file.fileName.trim() != "")
      {
        file.fileCategory = this.getFileCategory(file.fileName);
      }
      else{
        file.fileStatus = FileStatus.ERROR;
        file.url = undefined;
        file.canDownload = false;
        return;
      }

      const currentDate = new Date();
      const expirationDate = new Date(file.expirationDate!);
      if(file.fileCategory != "IMAGE" || (file.url != null && file.url != undefined && file.expirationDate && expirationDate >= currentDate))
      {
        if(file.url != null && file.url != undefined)
        {
          file.url = file.url!.trim();
        }
        if(file.fileCategory == "IMAGE" && file.url == "")
        {
          file.canDownload = false;
        }

        file.fileStatus = FileStatus.SUCCESS;
      }
      else if(!this.isPreview && file.azureFileName && file.azureFileName.trim() != "" && this.customerPageData.id){

        this.customerPageDataService.getFile(this.customerPageData.id, file.azureFileName)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (fileData: FileData) => {
            if (fileData) {
              file.fileStatus = FileStatus.SUCCESS;
              file.url = fileData.url?.trim() != "" ? fileData.url : "../../../../../../../assets/img/no-image.jpg";
              file.expirationDate = fileData.expirationDate;
            }
            else {
              file.url = undefined;
              file.fileStatus = FileStatus.ERROR;
              file.canDownload = false;
            }
          },
          error: (error) => {
            this.snackBar.showError(this.translationService.translate('Error fetching file'));
            file.fileStatus = FileStatus.ERROR;
            file.url = undefined;
            file.canDownload = false;
          }
        });
      }
      else if (!this.isPreview){
        file.fileStatus = FileStatus.ERROR;
        file.url = undefined;
        file.canDownload = false;
      }
    });
    this.fileData.notifyChanges();
    this.customerPageData.values = this.fileData
      .getFiles(this.component.id, this.dataGroupCustomerPageData.key)
      .filter(x => x.fileStatus == FileStatus.UPLOADING || x.fileStatus == FileStatus.SUCCESS) as FileData[];
    this.customersDataChange.emit(true);
  }

  handleInsertImage(event: Event): void {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0 && this.isEditable) {
      if (this.customerPageData.id == undefined || this.customerPageData.id == '00000000-0000-0000-0000-000000000000') {
        this.onSave();
      }

      var files = inputElement.files;
      Array.from(files).forEach(file => {
        const fileData: FileData = {
          fileName: file.name,
          fileStatus: FileStatus.UPLOADING,
          fileType: file.type,
          file: file,
          azureFileName: this.isPreview ? this.utils.generateGUID() : undefined,
          url: undefined,
          expirationDate: undefined,
          canDownload: false,
          type: this.component.type == ComponentType.VISUAL_PUBLICATION ? this.component.config?.contentAPISubType : undefined,
          identifier: undefined
        };

        this.fileData.addFile(this.component.id, this.dataGroupCustomerPageData.key, fileData);
      });

      // Array to store upload promises
      const uploadPromises = this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key)
        .filter(x => x.fileStatus == FileStatus.UPLOADING)
        .map((fileData) => {
          if (fileData.file != null && this.customerPageData.id) {
            if (!this.isPreview && this.isEditable) {
              // Return a promise from the uploadFile function using toPromise()
              return this.customerPageDataService.uploadFile(this.customerPageData, fileData.file).toPromise().then(
                (result: FileData | undefined) => {
                  if (result) {

                    this.loadFile(fileData);
                    fileData.azureFileName = result.azureFileName;
                    inputElement.value = '';
                    this.recalculateTooltipsPosition.emit();
                  } else {
                    // Set error status and display error message if upload fails
                    fileData.fileCategory = 'ERROR_FILE';
                    fileData.fileStatus = FileStatus.ERROR;
                    fileData.url = undefined;
                    this.snackBar.showError(this.translationService.translate('Error uploading file'));
                    this.recalculateTooltipsPosition.emit();
                  }
                },
                (error) => {
                  // Set error status and display error message if there is an error during upload
                  fileData.fileStatus = FileStatus.ERROR;
                  fileData.url = undefined;
                  this.snackBar.showError(this.translationService.translate('Error uploading file'));
                  this.recalculateTooltipsPosition.emit();
                }
              );
            } else {
              // If it's a preview, reset the input and resolve immediately
              this.loadFile(fileData);
              inputElement.value = '';
              return Promise.resolve();
            }
          }
          // Return a resolved promise if file or customerPageData.id is not set
          return Promise.resolve();
        });

      // Execute onSave only when all promises have completed
      Promise.all(uploadPromises).then(() => {
        this.evaluateField();
        if (this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key).filter(x => x.fileStatus != FileStatus.ERROR).length > 0) {
          this.onSave();
        }
      });
    }
  }

  loadFile(fileData: FileData)
  {
    const reader = new FileReader();
    reader.onload = () => {
      const fileCategory = this.getFileCategory(fileData.file!.name);
      fileData.fileCategory = fileCategory;
      fileData.fileStatus = FileStatus.SUCCESS;
      if (fileCategory == "IMAGE") {
        fileData.url = reader.result as string;
      } else if (fileCategory == "WRONG_EXTENSION") {
        fileData.fileStatus = FileStatus.ERROR;
      }
    };
    reader.onerror = (error) => {
      fileData.fileCategory = 'ERROR_FILE';
      fileData.fileStatus = FileStatus.ERROR;
      fileData.url = undefined;
    };
    reader.readAsDataURL(fileData.file!);
  }

  actionDeleteFile(e: MouseEvent, file: FileData): void {
    e.preventDefault();
    e.stopPropagation();
    if (file.fileStatus != FileStatus.ERROR) {
      this.dialogService.confirm(this.translationService.translate('Confirm Delete'), this.translationService.translate('Are you sure you want to delete this file?')).then((confirmed) => {
        if (confirmed) {
          this.deleteFile(file);
        }
      });
    }
    else {
      this.deleteFile(file);
    }

  }
  deleteFile(file: FileData): void {
    this.fileData.removeFile(this.component.id, this.dataGroupCustomerPageData.key, file);
    this.customerPageData.values = this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key).filter(x => x.fileStatus == FileStatus.UPLOADING || x.fileStatus == FileStatus.SUCCESS) as FileData[];
    this.customersDataChange.emit(true);

    setTimeout(() => {
      if (!this.isPreview && (file.azureFileName || file.identifier) && this.customerPageData.id) {
        var target = (file.azureFileName && file.azureFileName.length > 0) ? file.azureFileName : file.identifier;

        var completionPercent = this.customerPage.completionPercent ?? 0;
        this.customerPageDataService.deleteFile(this.customerPageData.id, target!, completionPercent)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (result: boolean) => {},
            error: (error) => {
              this.snackBar.showError(this.translationService.translate('Error on deleting this file'));
            }
          });
      }
      this.evaluateField();
    }, 0);
  }
  async downloadFile(file: FileData)
  {
    if(!this.isPreview && file.fileStatus != FileStatus.ERROR && file.url != undefined && file.url != null && file.url != "" && !file.url.startsWith("data:") && this.customerPageData.id && (file.azureFileName || file.identifier))
    {
        if(file.blob)
        {
          this.performDownload(file.blob, file.fileName);
        }
        else if(file.azureFileName && file.azureFileName.length > 0)
        {
          this.customerPageDataService.downloadFile(this.customerPageData.id, file.azureFileName)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (blob: Blob) => {
              if (blob) {
                this.performDownload(blob, file.fileName);
                if(file.fileCategory == "IMAGE")
                {
                  file.blob = blob;
                }
              }
              else{
                this.snackBar.showError(this.translationService.translate('Error on downloading this file'));
                file.canDownload = false;
                file.blob = undefined;
              }
            },
            error: (error) => {
              this.snackBar.showError(this.translationService.translate('Error on downloading this file'));
              file.canDownload = false;
              file.blob = undefined;
            }
          });
        }
        else if(file.identifier && file.identifier.length > 0)
        {
          const response = await fetch(file.url);
          const blob = response.blob();

          blob.then(blob => {
            if (blob) {
              this.performDownload(blob, file.fileName);
              if(file.fileCategory == "IMAGE")
              {
                file.blob = blob;
              }
            }
            else{
              this.snackBar.showError(this.translationService.translate('Error on downloading this file'));
              file.canDownload = false;
              file.blob = undefined;
            }
          });
        }
    }
    else{
      //Dont download when: preview or base64
      file.canDownload = false;
      file.blob = undefined;
    }
  }

  performDownload(blob: Blob, fileName?: string)
  {
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName && fileName != "" ? fileName : "empty-name";
    a.click();

    URL.revokeObjectURL(blobUrl);
  }



  isFileCategoryArray(values: any): values is FileCategory[] {
    return Array.isArray(values) && values.every(value => {
      return value && typeof value.name === 'string' && Array.isArray(value.extensions);
    });
  }

  getFileCategory(filename: string): string {
    let fileType: string = 'WRONG_EXTENSION';
    let extension: string;
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
      extension = "";
    }
    extension = filename.substring(lastDotIndex);
    var category = this.allFileCategories.filter(x => x.values.includes(extension))[0];
    if (category != null)
      fileType = category.type;

    return fileType;
  }
  //#endregion

  //#region ADDRESS
  isFirstTime = true;
  get customerPageDataValuesInAddress(): ContentAddress[] {
    const values = this.customerPageData.values;

    if (Array.isArray(values) && values.length > 0) {
      const firstValue = values[0];
      if (typeof firstValue === 'object') {
        var addresses = values as ContentAddress[];
        addresses.forEach(address => {
          const addressParts = [
            address.number,
            address.complementLabel,
            address.trackType,
            address.laneLabel
          ].filter(part => part != null && part !== '');

          if (this.isFirstTime && !address.extendedWayLabel && addressParts.length > 0) {
            address.extendedWayLabel = addressParts.join(' ');
          }
        });
        this.isFirstTime = false;
        return addresses;
      }
    }
    this.isFirstTime = false;
    return [];
  }

  onAddressSave(){
    this.isAddressValid = true;
    this.evaluateField();

    //if all empty dont evaluate
    if(this.utils.checkAddressFullEmpty(this.customerPageData.values as ContentAddress[]) && !this.component.isRequired && this.hasConnectionsOut)
    {
      this.editing = !this.editing;
      return;
    }

    if(!this.utils.checkAddressFilled(this.customerPageData.values as ContentAddress[]))
    {
      this.isAddressValid = false;
    }

    if(this.isAddressValid || !this.editing)
    {
      if(this.editing)
      {
        this.onSave();
        this.evaluateField();
      }

      if(this.hasConnectionsOut){
        this.editing = !this.editing;
      }
    }
  }

  onAddressFieldChanged()
  {
    if(this.hasConnectionsOut){
      //with btn
      this.isAddressValid = true;

      if(!this.utils.checkAddressFullEmpty(this.customerPageData.values as ContentAddress[]) && !this.utils.checkAddressFilled(this.customerPageData.values as ContentAddress[]))
      {
        this.isAddressValid = false;
      }
      this.evaluateField();
    }
    else{
      //without btn (instante save)
      this.onAddressSave();
    }
  }

  private validateAddress(value: any, index?: string): string | null {
    if (index != null) {
      return this.validateAddressField(value, index);
    } else {

      return this.isEditable
      && (this.component.isRequired || this.editing)
      && !this.utils.checkAddressFilled(this.customerPageData.values as ContentAddress[])
      && (!this.utils.checkAddressFullEmpty(this.customerPageData.values as ContentAddress[]) || this.component.isRequired)
        ? this.translationService.translate('This field is required')
        : null;
    }
  }

  private validateAddressField(value: any, index: string): string | null {
    if (value == null) {
      return this.translationService.translate('Invalid address');
    }
    const messageError = this.validateAddress(value);
    return messageError ? messageError : null;
  }

  //#endregion

  //#region INTITULE
  get customerPageDataValuesInIntitule(): ContentIntitule[] {
    const values = this.customerPageData.values;

    if (Array.isArray(values) && values.length > 0) {
      const firstValue = values[0];

      if (typeof firstValue === 'object') {
        return values as ContentIntitule[];
      }
    }
    return [];
  }

  onIntituleSave(){
    if(!this.evaluateField())
    {
      this.onSave();
    }
  }

  private validateIntitule(value: any, index?: string): string | null {
    if (index != null) {
      return this.validateIntituleField(value, index);
    } else{
      return this.isEditable && this.component.isRequired && !this.utils.checkIntituleFilled(this.customerPageData.values as ContentIntitule[])
        ? this.translationService.translate('This field is required')
        : null;
    }
  }

  private validateIntituleField(value: any, index: string): string | null {
    if (value == null) {
      return this.translationService.translate('Invalid denomination');
    }
    const messageError = this.validateIntitule(value);
    return messageError ? messageError : null;
  }
  //#endregion

  //#region URL
  get customerPageDataValuesInUrl(): ContentUrl[] {
    const values = this.customerPageData.values;

    if (Array.isArray(values) && values.length > 0) {
      const firstValue = values[0];

      if (typeof firstValue === 'object') {
        return values as ContentUrl[];
      }
    }
    return [];
  }

  onUrlSave(urlChanged: ContentUrl | null = null, index: number | null = null){
    this.isUrlValid = true;

    if(!this.utils.checkUrlsWellFilled(this.customerPageDataValuesInUrl, this.urlTypes))
    {
      this.isUrlValid = false;
    }

    if(!this.isUrlValid && urlChanged && !this.utils.checkUrlFilled(urlChanged))
    {
      if(index != null){
        this.cleanTooltipError(index.toString());
      }
      return;
    }

    // Auto-fix: prepend "https://" if the URL is invalid solely because it lacks a protocol.
    if(!this.isUrlValid && urlChanged && index != null && !urlChanged.label.startsWith("https://") && !urlChanged.label.startsWith("http://")){
      var urlTest: ContentUrl = {
        ...urlChanged,
        label: "https://" + urlChanged.label
      };

      if(this.utils.checkUrlWellFilled(urlTest, this.urlTypes)){
        this.customerPageDataValuesInUrl[index] = urlTest;
      }
    }

    if(this.customerPageDataValuesInUrl.length > 0)
    {
      this.customerPageDataValuesInUrl.forEach((url, index) => {
        this.evaluateField(url, index.toString());
      });
    }

    if(this.isUrlValid)
    {
      const oldValues = this.oldValues as ContentUrl[];
      const newValues = this.customerPageData.values as ContentUrl[];
      if(this.hasContentUrlChanges(oldValues, newValues)){
        this.oldValues = structuredClone(this.customerPageData.values);
        this.onSave();
      }
    }
  }


  hasContentUrlChanges(
    oldValues: ContentUrl[],
    newValues: ContentUrl[]
  ): boolean {
    if (oldValues.length !== newValues.length) {
      return true;
    }

    const oldMap = new Map<string, ContentUrl>();
    for (const item of oldValues) {
      oldMap.set(item.identifier, item);
    }

    for (const newItem of newValues) {
      const oldItem = oldMap.get(newItem.identifier);

      if (!oldItem) {
          return true;
      }

      if (
        oldItem.label !== newItem.label ||
        oldItem.type !== newItem.type
      ) {
        return true;
      }
      oldMap.delete(newItem.identifier);
  }
    return false;
  }

  onUrlFieldChanged(value?:any, index?: any)
  {
    this.isUrlValid = true;

    if(!this.utils.checkUrlsWellFilled(this.customerPageDataValuesInUrl, this.urlTypes))
    {
      this.isUrlValid = false;
    }
    this.evaluateField(value, index);
  }

  private validateUrl(value: any, index?: string): string | null {
    if (index != null) {
      return this.validateUrlField(value, index);
    }
    else if(this.isEditable && this.component.isRequired)
    {
      if(!this.utils.checkUrlsFilled(this.customerPageDataValuesInUrl))
      {
        return this.translationService.translate('This field is required');
      }
      else if(!this.utils.checkUrlsWellFilled(this.customerPageDataValuesInUrl, this.urlTypes))
      {
        return this.translationService.translate('This field has a wrong domain or protocol');
      }
    }

    return null;
  }

  private validateUrlField(url: ContentUrl | undefined, index: string): string | null {
    if (url == undefined) {
      return this.translationService.translate('Invalid url');
    }
    else if(this.utils.checkUrlFullEmpty(url))
    {
      if(this.component.isRequired && (this.component.multipleConfig?.minQuantity == undefined || this.component.multipleConfig!.minQuantity! >= (parseInt(index)+1)))
      {
        return this.translationService.translate('This field is required');
      }
    }
    else if(!this.utils.checkUrlWellFilled(url, this.urlTypes))
    {
      const typeDef = this.urlTypes.find(t => t.code === url.type);
      if(!url.type)
      {
        return this.translationService.translate('This field is required');
      }
      else if(!url.label){
        if(this.component.isRequired)
        {
          return this.translationService.translate('This field is required');
        }
      }
      else if(!url.label.startsWith("https://") && !url.label.startsWith("http://"))
      {
        return this.translationService.translate('The URL must start with') +' \"https://\"';
      }
      else if(typeDef && typeDef.domains && typeDef.domains.length > 0){
        return this.translationService.translate('The URL does not belong to the domain(s)') + ":\n-" + typeDef?.domains?.join("\n-");
      }
      else if(url.type == "TWITTER" && !this.utils.twitterUrlHasGoodStructure(url.label)){
        return this.translationService.translate('The URL does not belong to the domain(s)') + ":\n-x.com";
      }
      else if(!this.utils.urlHasGoodStructure(url.label))
      {
        return this.translationService.translate('The URL is invalid');
      }
    }

    return null;
  }
  //#endregion

  //#region ACTIVITY_PRESTATIONS
  get customerPageDataValuesInActivityPrestations(): ContentActivityPrestations[] {
    const values = this.customerPageData.values;

    if (Array.isArray(values) && values.length > 0) {
      const firstValue = values[0];

      if (typeof firstValue === 'object') {
        return values as ContentActivityPrestations[];
      }
    }
    return [];
  }

  onActivityPrestationsSave(){
    //update available prestations
    var activityPrestations = this.customerPageDataValuesInActivityPrestations[0];
    const activityCode = activityPrestations.activity?.code;
    this.selectedActivityCode.next(activityCode);

    if(activityPrestations)
    {
      this.evaluateField(activityPrestations, "0");

      if(activityPrestations.prestations.length > 0)
      {
        this.activityCtrl.disable();
      }
      else{
        this.activityCtrl.enable();
      }
    }

    if(this.utils.checkActivityPrestationsFilled(this.customerPageDataValuesInActivityPrestations))
    {
      this.onSave();
    }
  }

  private validateActivityPrestations(): string | null {
    if(this.isEditable && this.component.isRequired)
    {
      if(!this.utils.checkActivityPrestationsFilled(this.customerPageDataValuesInActivityPrestations))
      {
        return this.translationService.translate('This field is required');
      }
    }

    return null;
  }

  displayActivity = (activity: ContentActivity): string => {
    return activity && activity.label ? activity.label : '';
  };

  onActivitySelected(selectedActivity: ContentActivity) {
    var mainIndicator = this.customerPageDataValuesInActivityPrestations[0].activity ? this.customerPageDataValuesInActivityPrestations[0].activity.mainIndicator : false;
    selectedActivity.mainIndicator = mainIndicator;
    this.activityCtrl.setValue(selectedActivity);
    this.customerPageDataValuesInActivityPrestations[0].activity = selectedActivity;

    this.updateAvailableActivityPrestations(selectedActivity.code);
    this.onActivityPrestationsSave();

    this.activityChanged.emit();
  }

  updateAvailableActivities(){
    var availableActivities = this.calculateActivities();
    this.allActivities$.next(availableActivities);

    // this.componentConditionedClosedForms
    // .filter(c => c.component.type == ComponentType.ACTIVITY_PRESTATIONS)
    // .forEach(c =>
    //   setTimeout(() => {
    //     c.updateAvailableActivities()
    //   }, 0)
    // );
  }

  calculateActivities(){
    return this.refBusinessLists.activities?.map((a): ContentActivity => ({
      code: a.code,
      label: a.labelBusiness
    })).filter(a => !this.activitiesAlreadySelected.includes(a.code)) ?? [];
  }

  onConditionedActivityChanged(){
    this.activityChanged.emit();
  }

  onSelectActivityFocusOut(){
    this.activitySearchCtrl.setValue('');
    setTimeout(() => {
      this.resetSelect();
    }, 150);
  }

  onSelectActivitySearchEnter(event: Event): void {
    event.preventDefault();

    if (this.activeOption && this.activeOption.value) {
      this.onActivitySelected(this.activeOption.value);
      this.autocompleteTrigger.closePanel();
    }
  }

  filterPrestations(activityCode: string, searchedPrestation?: string|null|undefined): ContentExpression[] {
    var prestations = this.availableActivityPrestations.filter(prestation =>
      !searchedPrestation || prestation.labelBusiness.toLowerCase().includes(searchedPrestation.toLowerCase())
    );

    return prestations?.map((p): ContentExpression => ({
      code: p.code,
      label: p.labelBusiness
    }));
  }

  displayPrestation = (prestation: ContentExpression): string => {
    return prestation && prestation.label ? prestation.label : '';
  };

  onPrestationSelected(selectedPrestation: ContentExpression, activityCode: string): void {
    clearTimeout(this.blurTimeout);

    var activityPrestations = this.customerPageDataValuesInActivityPrestations.find(v => v.activity?.code == activityCode);
    if (selectedPrestation && activityPrestations) {
      if(!activityPrestations.prestations)
      {
        activityPrestations.prestations = [];
      }

      if(activityPrestations.prestations && !activityPrestations.prestations.map(p => p.code).includes(selectedPrestation.code))
      {
        activityPrestations.prestations.push(selectedPrestation);
      }
    }

    if(this.prestationInput)
    {
      this.prestationInput.nativeElement.value = '';
    }
    this.prestationCtrl.setValue(null);
    this.onActivityPrestationsSave();
  }

  onSelectPrestationFocusOut()
  {
    this.blurTimeout = setTimeout(() => {
      if (this.prestationInput) {
        this.prestationInput.nativeElement.value = '';
      }
      this.prestationCtrl.setValue(null, { emitEvent: false });
      this.resetSelect();
    }, 150);
  }

  removePrestation(prestation: ContentExpression, activityCode: string): void {
    var activityPrestations = this.customerPageDataValuesInActivityPrestations.find(v => v.activity?.code == activityCode);
    const index = activityPrestations?.prestations?.indexOf(prestation);

    if (index != undefined && index >= 0) {
      activityPrestations!.prestations.splice(index, 1);
      this.prestationCtrl.updateValueAndValidity();
      this.onActivityPrestationsSave();
    }
  }

  updateAvailableActivityPrestations(activityCode?: string)
  {
    this.availableActivityPrestations = this.refBusinessLists.prestations ?
      this.refBusinessLists.prestations.filter(prestation => !activityCode || prestation.activityCode == activityCode)
      : [];
    this.hasAvailablePrestations = this.availableActivityPrestations.length > 0;
  }

  onUpdateActivityPrestationMainIndicator(mainIndicator: boolean, needSave: boolean){
    this.customerPageDataValuesInActivityPrestations[0].activity!.mainIndicator = mainIndicator;
    if(needSave){
      this.onActivityPrestationsSave();
    }
    this.customersDataChange.emit(true);
  }

  //#endregion

  //color picker
  get customerPageDataValuesInColorPicker(): ColorPicker[] {
    const values = this.customerPageData.values;

    if (Array.isArray(values) && values.length > 0) {
      const firstValue = values[0];

      if (typeof firstValue === 'object') {
        return values as ColorPicker[];
      }
    }
    return [];
  }

  preventInput(event: KeyboardEvent) {
    event.preventDefault();
  }

  onCustomerPageDataChange() {
    this.customersDataChange.emit(true);
  }

  hasAlphaZero(color: string): boolean {
    return this.utils.hasAlphaZero(color);
  }

  handleColorPicker(treatColor: boolean, value?: any, index?: any)
  {
    if (treatColor && this.hasAlphaZero(value.color)) {
      if(value.value.startsWith('rgba'))
      {
        value.value = value.value.replace(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*\d*\.?\d*\)/, 'rgba($1, $2, $3, 1)');
        value.value = this.utils.rgbaToHex(value.value);
      }
      else if(value.value.startsWith('#'))
      {
        let hex = value.value.replace(/^#/, '');
        if (hex.length === 6) {
          hex += 'FF';
        }
        else if (hex.length === 8) {
            hex = hex.slice(0, 6) + 'FF';
        }
        value.value = `#${hex}`;
      }
    }

    this.customersDataChange.emit(true);
  }

  onSliderChange(newColor: string, index: number) {
    var value = this.customerPageData.values[index] as ColorPicker;
    value.color = newColor;
    this.handleColorPicker(true, value, index);
  }

  adjustAllTextareasHeight() {
    this.textareas.forEach((textarea: ElementRef) => {
      this.utils.adjustTextareaHeight(textarea.nativeElement);
    });
  }

  adjustTextareaHeight(event: Event): void {
    this.utils.adjustTextareaHeight(event.target as HTMLTextAreaElement);
    this.recalculateTooltipsPosition.emit();
  }

  resetSelectOption(event: Event) {
    event.stopPropagation();
    if (this.component.config?.selectType == SelectType.LIST_DROP) {
      if (!this.component.config?.multipleAnswers) {
        this.optionCtrl.setValue(null);
        this.onSelectSingleChange('');
      }
      else {
        this.customerPageData.values = [];
        this.onSelectMultipleChange();
      }
    }
  }

  onScheduleSave() {
    this.onSave();
    this.evaluateField();
  }

  @Output() tooltipPosition = new EventEmitter<TooltipPosition>();
  errorMessages: { [key: string]: string } = {};

  evaluateField(value?: any, index?: string, displayErrors: boolean = true): boolean {
    const key = `${this.generatedIndex}${index ? `-${index}` : ''}`;
    const errorMessage = this.getValidationErrorMessage(value, index);
    const hasError = errorMessage != null && errorMessage != undefined && errorMessage.length > 0;

    if(displayErrors){
      if (hasError) {
        this.errorMessages[key] = errorMessage;
      } else {
        delete this.errorMessages[key];
      }

      this.emitTooltipPosition(hasError, key);
    }
    return hasError;
  }

  cleanTooltipError(index: string){
    const key = `${this.generatedIndex}${index ? `-${index}` : ''}`;
    delete this.errorMessages[key];
    this.emitTooltipPosition(false, key);
  }

  private getValidationErrorMessage(value?: any, index?: string): string | null {
    if (this.component.type === ComponentType.INPUT) {
      if (this.component.config?.inputType === InputType.COLOR_PICKER) {
        return this.validateColorPicker(value, index??"0");
      } else if (this.component.config?.inputType === InputType.FILE) {
        return this.validateFile();
      } else {
        return this.validateInput(value, index??"0");
      }
    }
    else if (this.component.type === ComponentType.SELECT) {
      return this.validateSelect();
    }
    else if (this.component.type === ComponentType.SCHEDULE) {
      return this.validateSchedule(value, index);
    }
    else if(this.component.type === ComponentType.CHECKBOX)
    {
      return this.validateCheckbox();
    }
    else if(this.component.type === ComponentType.ADDRESS)
    {
      return this.validateAddress(value, index);
    }
    else if(this.component.type === ComponentType.INTITULE)
    {
      return this.validateIntitule(value, index);
    }
    else if(this.component.type === ComponentType.URL)
    {
      return this.validateUrl(value, index);
    }
    else if(this.component.type === ComponentType.VISUAL_PUBLICATION)
    {
      return this.validateFile();
    }
    else if(this.component.type === ComponentType.ACTIVITY_PRESTATIONS)
    {
      return this.validateActivityPrestations();
    }
    return null;
  }

  private validateColorPicker(value: any, index: string): string | null {
    return this.isEditable
    && this.component.isRequired
    && !value.text
    && this.hasAlphaZero(value.color)
    && (this.component.multipleConfig?.minQuantity == undefined || this.component.multipleConfig!.minQuantity! >= (parseInt(index)+1))
      ? this.translationService.translate('This field is required')
      : null;
  }

  private validateFile(): string | null {
    return this.isEditable && this.component.isRequired && this.fileData.getFiles(this.component.id, this.dataGroupCustomerPageData.key).length === 0
      ? this.translationService.translate('This field is required')
      : null;
  }

  private validateInput(value: any, index: string): string | null {
    if (this.isEditable && this.component.isRequired && !value) {
      if(this.component.multipleConfig?.minQuantity == undefined || this.component.multipleConfig!.minQuantity! >= (parseInt(index)+1))
      {
        return this.translationService.translate('This field is required');
      }
    } else if (this.isEditable && value) {
      var isMaskComplete = true;
      if(this.component.config?.mask?.mask)
      {
        const isDynamicMask = this.component.config?.mask?.mask.startsWith('separator') ||
                            this.component.config?.mask?.mask.startsWith('percent') ||
                            this.component.config?.mask?.mask.startsWith('money');
        if(!isDynamicMask){
          var baseMask = this.component.config.mask.mask.replace(/[\*9]/g, ''); //remove * and optionals
          if (this.component.config.mask.dropSpecialCharacters) {
            baseMask = baseMask.replace(/[^0-9a-zA-Z]/g, ''); //remove special chars
          }

          isMaskComplete = value.length >= baseMask.length;
        }
      }

      const pattern = this.component.config?.mask?.writeRegex || this.component.regex;
      const isRegexValid = pattern ? new RegExp(pattern).test(value) : true;

      if (!isMaskComplete || !isRegexValid) {
        return this.translationService.translate('Incorrect entry. Please check the information.');
      }
    }
    return null;
  }

  private validateSelect(): string | null {
    var opts = this.component.config?.options?.map(x => x.value) || [];
    var vals = this.customerPageData.values as string[];
    const hasIntersection = vals.some(v => opts.includes(v));

    return this.isEditable && this.component.isRequired && (this.isAllValuesComponentEmpty() || !hasIntersection)
      ? this.translationService.translate('This field is required')
      : null;
  }

  private validateCheckbox(): string | null {
    return this.isEditable && this.component.isRequired && this.isAllValuesComponentEmpty()
      ? this.translationService.translate('This field is required')
      : null;
  }

  private validateSchedule(value: any, index?: string): string | null {
    if (index != null) {
      return this.validateSchedulePeriod(value, index);
    } else {
      return this.isEditable && this.component.isRequired && !this.utils.checkScheduleFilled(this.customerPageData.values as Schedule[])
        ? this.translationService.translate('This field is required')
        : null;
    }
  }

  private validateSchedulePeriod(value: any, index: string): string | null {
    if (value == null) {
      return this.translationService.translate('Invalid schedule period');
    }
    const messageError = this.getPeriodValidationError(value, this.getSelectedDayPeriods());
    return messageError ? messageError : null;
  }


  emitTooltipPosition(show: boolean, key: string) {
    const tooltipPosition: TooltipPosition = {
      show: show,
      index: key
    };
    this.tooltipPosition.emit(tooltipPosition);
  }

  updateTooltipListPositions(startIndex: number) {
    const updatedErrorMessages: { [key: string]: string } = {};
    for (const key in this.errorMessages) {
      const parts = key.split("-");
      var lastIndex = parts.length - 1;
      const index = parseInt(parts[lastIndex]);

      if (index > startIndex) {
        const newIndex = index - 1;
        const newKey = `${this.generatedIndex}-${newIndex}`;
        updatedErrorMessages[newKey] = this.errorMessages[key];
        this.evaluateField(null, newIndex.toString());
      }
      else {
        updatedErrorMessages[key] = this.errorMessages[key];
      }
    }

    this.errorMessages = updatedErrorMessages;
  }

  @ViewChildren(ComponentFormComponent) componentConditionedClosedForms!: QueryList<ComponentFormComponent>;
  //Send request for all fields to do evaluate, from group
  evaluateAllComponentFields(requestedByPage: boolean, displayErrors: boolean): boolean {
    var hasErrors = false;
    if (this.customerPageData.values.length === 0) {
      hasErrors = this.evaluateField(null, undefined, displayErrors);
    }

    const isSpecialType =
      this.component.type === ComponentType.SCHEDULE ||
      this.component.type === ComponentType.ADDRESS ||
      this.component.type === ComponentType.INTITULE ||
      this.component.type === ComponentType.SELECT ||
      (this.component.type === ComponentType.INPUT && this.component.config?.inputType === InputType.FILE) ||
      this.component.type === ComponentType.VISUAL_PUBLICATION ||
      this.component.type === ComponentType.CHECKBOX;

    this.customerPageData.values.forEach((value, index) => {
      const indexString = isSpecialType ? undefined : index.toString();
      hasErrors = this.evaluateField(value, indexString, displayErrors);

      if (this.component.type === ComponentType.SCHEDULE && this.isEditable && this.editing && this.isScheduleValid) {
        this.onScheduleSave();
      }

      if (this.component.type === ComponentType.ADDRESS && this.isEditable && this.editing && this.isAddressValid) {
        this.onAddressSave();
      }
    });

    if(requestedByPage)
    {
      //check errors on components conditioned close
      this.componentConditionedClosedForms.forEach(componentConditionedClosedForms => {
        var closedHasErrors = componentConditionedClosedForms.evaluateAllComponentFields(false, displayErrors);

        if (!hasErrors && closedHasErrors) {
          hasErrors = closedHasErrors;
        }
      });
    }

    return hasErrors;
  }

  limitDigits(event: Event, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    if (value.length > 16) {
      value = value.slice(0, 16);
      inputElement.value = value;
    }

    this.customerPageData.values[index] = value;
  }

  sanitizeHtml(text: string)
  {
    return this.utils.sanitizeHtml(text);
  }
  recalculateTooltipsPositionEmit()
  {
    this.recalculateTooltipsPosition.emit();
  }

  onSingleCheckboxChange(event: MatCheckboxChange): void {
    let values = this.customerPageData.values as string[];
    if (event.checked) {
      values[0] = "1";
      this.isCheckboxComponentChecked = true;
    } else {
      values[0] = "0";
      this.isCheckboxComponentChecked = false;
    }
    this.evaluateField(this.isCheckboxComponentChecked);
    this.onSave();
  }


  // @ViewChild('tooltip') tooltip: MatTooltip | undefined;

  // toggleTooltip(): void {
  //   if (this.tooltip) {
  //     if (this.tooltip._isTooltipVisible()) {
  //       this.tooltip.hide();
  //     } else {
  //       this.tooltip.show();
  //     }
  //   }
  // }

  private activeTooltip: MatTooltip | null = null;

  toggleTooltip(tooltip: MatTooltip): void {
    if(!this.utils.isDesktop())
    {
      if (this.activeTooltip && this.activeTooltip !== tooltip) {
        this.activeTooltip.hide();
      }

      if (tooltip._isTooltipVisible()) {
        tooltip.hide();
        this.activeTooltip = null;
      } else {
        tooltip.show();
        this.activeTooltip = tooltip;
      }
    }
  }

  activateEdit(tooltipIndex: string)
  {
    if(!this.editing && !this.isSummary && this.isEditable && this.hasConnectionsOut)
    {
      this.editing = true;
    }
    this.displayCurrentErrorTooltip(tooltipIndex);
  }

  getFileExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return '';
    }
    return filename.substring(lastDotIndex + 1).toLowerCase();
  }

  displayCurrentErrorTooltip(tooltipIndex: string)
  {
    if(tooltipIndex)
    {
      //recalculate error tooltip
      const tooltipElement = document.querySelector(`.tooltip-${tooltipIndex}`) as HTMLElement;
      var hasError: boolean = tooltipIndex in this.errorMessages;
      if(hasError)
      {
        if(!tooltipElement || getComputedStyle(tooltipElement).display == "none")
        {
          this.emitTooltipPosition(hasError, tooltipIndex);
        }
      }
      //close other opened error tooltips
      this.closeAllTooltipsExceptCurrent.emit(tooltipIndex);
    }
  }

  closeAllTooltipsExceptCurrentEmit(tooltipIndex: string)
  {
    this.closeAllTooltipsExceptCurrent.emit(tooltipIndex);
  }

  private onHtmlClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const link = target.closest('a[data-href]') as HTMLAnchorElement;

    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const href = link.dataset['href'];
    if (!href) return;

    window.open(href, '_blank', 'noopener');
  };

  isAndroidOrWindows() {
    return this.utils.isAndroidOrWindows();
  }

  formatOnRead(){
    const mask = this.component.config?.mask;
    if(mask?.readRegex && mask?.readFormat){
      const regex = new RegExp(mask.readRegex);

      this.customerPageData.values = this.customerPageData.values.map(val => {
        if (val === null || val === undefined || val === '') return val;
        const stringVal = String(val);

        if (regex.test(stringVal)) {
          return stringVal.replace(regex, mask.readFormat!);
        }

        return stringVal;
      });
    }
  }

  showMaskTypedList: { [key: string]: boolean } = {};
  toggleMask(index: number, isOpen: boolean) {
    if(this.component.config?.mask && this.component.config?.mask?.mask){
      const key = `${this.generatedIndex}-${index}`;
      this.showMaskTypedList[key] = isOpen;
    }
  }


  onCardSelectionChange(clickedValue: string): void {
    const isMultiple = this.component.config?.multipleAnswers === true;

    // Ensure the values array exists
    if (!this.customerPageData.values) {
      this.customerPageData.values = [];
    }

    // Capture the original array reference in memory
    let values = this.customerPageData.values as string[];

    if (isMultiple) {
      // MULTIPLE ANSWERS (Checkbox Logic)
      const index = values.indexOf(clickedValue);

      if (index > -1) {
        values.splice(index, 1); // Remove
      } else {
        values.push(clickedValue); // Add
      }

    } else {
      // SINGLE ANSWER (Radio Logic)
      // Clear the existing array keeping the same memory reference.
      values.length = 0;

      // Add the newly clicked value
      values.push(clickedValue);
    }

    this.evaluateField();
    this.onSave();
  }

  getGridColumns(component: any): number {
    // Desktop
    var optionsLength = component.config?.options?.length || 0;
    var deskColumns = component.columns!;
    var columns = optionsLength < deskColumns ? (optionsLength || 1) : deskColumns;

    // Tablet
    if (this.utils.isTablet() && columns > 2) {
      columns = 2;
    }

    // Mobile
    if (this.utils.isSmartphone() && columns > 1) {
      columns = 1;
    }

    return columns;
  }

  stripHtml(html: string): string{
    return this.utils.stripHtml(html);
  }

  isHtml(value: string){
    return this.utils.containsHtml(value);
  }
}
